module.exports = __webpack_public_path__ + "static/img/img_activity_a.ec9661c6.png";